module.exports = __webpack_public_path__ + "img/mic-button-disabled.f51428d1.svg";